import { EMPTY_OPTION_VALUE as t } from "../../constants/index.js";

import e from "./SelectedOptions/index.js";

const i = (...t) => {}, s = (t, ...e) => t, n = (...t) => !1, h = (t, ...e) => t(), l = t => t.toLowerCase(), o = (t, e) => e, a = "None", r = (t, e) => {
    if (t === e) return !1;
    if (t.length !== e.length) return !0;
    for (let i = t.length; i--; ) if (t[i] !== e[i]) return !0;
    return !1;
}, g = t => {
    t._inBatch++;
}, p = t => {
    t._somethingChanged = !0;
}, d = t => t.inputElement?.focus(), u = (t, e) => {
    d(t);
    const i = +e.target.getAttribute("data-option-index");
    t.toggleOption(t.selectedOptions.at(i));
}, c = (t, e) => e.target.previousElementSibling?.focus(), O = {
    ArrowLeft: c,
    ArrowRight: (t, e) => e.target.nextElementSibling?.focus(),
    Delete: u,
    Backspace: u,
    " ": d
}, f = {
    ArrowUp: (t, e) => {
        e.preventDefault(), t.toggle(!0), t.highlightRelative(t.highlightedOptionIndex, -1), 
        t.scr();
    },
    ArrowDown: (t, e) => {
        e.preventDefault(), t.toggle(!0), t.highlightRelative(t.highlightedOptionIndex, 1), 
        t.scr();
    },
    ArrowLeft: (t, e) => {
        t.multiple && t.selectOptions.length && "INPUT" === e.target.tagName && 0 === e.target.selectionStart && c(0, e);
    },
    Home: (t, e) => {
        e.preventDefault(), t.toggle(!0), t.highlight(0) || t.highlightRelative(0, 1), t.scr();
    },
    End: (t, e) => {
        e.preventDefault(), t.toggle(!0);
        const i = t.filteredOptions.length - 1;
        t.highlight(i) || t.highlightRelative(i, -1), t.scr();
    },
    Enter: (e, i) => {
        i.preventDefault(), e.opened ? e.highlightedOption !== t && (g(e), e.toggleOption(e.highlightedOption), 
        e.toggle(!1), e._endBatch()) : e.toggle(!0);
    },
    " ": (t, e) => {
        t.opened || (e.preventDefault(), t.toggle(!0));
    },
    Escape: (t, e) => {
        t.opened && (e.preventDefault(), t.toggle(!1));
    },
    Backspace: (t, e) => {
        !t.selectedOptions.length || "INPUT" === e.target.tagName && 0 !== e.target.selectionStart || (t => {
            d(t), t.toggleOption(t.selectedOptions.at(t.selectedOptions.length - 1));
        })(t);
    }
}, m = [];

function _(t) {
    return l(this.getOptionLabel(t)).includes(this._transformedFilterValue);
}

class b {
    id;
    menuId;
    _SUBS=[];
    _Queue=new Set;
    _inBatch=0;
    _somethingChanged=!1;
    lastKeyDownTimeStamp=0;
    inputElement=null;
    outerElement=null;
    disabled=!1;
    multiple=!1;
    opened=!1;
    clearable=!1;
    loading=!1;
    rawValueMode=!1;
    filterValue="";
    _transformedFilterValue="";
    noneOption=a;
    options=m;
    filteredOptions=m;
    getOptionLabel=s;
    getOptionValue=s;
    getOptionKey=o;
    isOptionDisabled=n;
    highlightedOptionIndex=-1;
    highlightedOption=t;
    selectedOptions=new e(this);
    onChange=i;
    onSearch=i;
    _queue(t) {
        this._Queue.add(t);
    }
    _endBatch() {
        0 == --this._inBatch && (this._Queue.size && (this._Queue.forEach(h), this._Queue.clear()), 
        this._somethingChanged && (this._SUBS.forEach(h), this._somethingChanged = !1));
    }
    on=t => (this._SUBS.push(t), () => this._SUBS.splice(this._SUBS.indexOf(t), 1));
    constructor(t, e) {
        this.id = t, this.menuId = t + "menu", this.set(e);
    }
    set({value: e, clearable: h = !1, disabled: l = !1, multiple: r = !1, loading: d = !1, rawValueMode: u = !1, options: c = m, getOptionValue: O = s, getOptionLabel: f = O, getOptionKey: _ = o, isOptionDisabled: b = n, onChange: v = i, onSearch: w = i, noneOption: D = a}) {
        null !== e && "" !== e || (e = t), this.multiple = r, this.rawValueMode = u, g(this), 
        d !== this.loading && (this.loading = d, p(this)), O !== this.getOptionValue && (this.getOptionValue = O, 
        p(this))
        /* do not need to rerender here */ , this.getOptionKey = _, this.onChange = v, this.onSearch = w, 
        this.clearable !== h && (this.clearable = h, p(this)), f !== this.getOptionLabel && (this.getOptionLabel = f, 
        p(this)), b !== this.isOptionDisabled && (this.isOptionDisabled = b, p(this)), D !== this.noneOption && (this.noneOption = D, 
        p(this));
        const V = h ? [ this.noneOption, ...c ] : c;
        var E, B;
        V !== this.options && (h && (E = c, B = this.noneOption, !E.find((t => t === B))) ? this.options = V : this.options = c, 
        p(this), this._queue(this.updateFilteredOptions)), "production" !== process.env.NODE_ENV && r && e !== t && !Array.isArray(e) && console.error("Multiple select accepts array of values. Got: ", {
            value: e
        });
        const S = e === t ? [] : r ? e : [ e ];
        this.selectOptions(u ? S : S.map((t => {
            const e = c.find((e => O(e) === t));
            if (void 0 === e) throw console.log({
                option: t
            }), new Error("Passed option cannot be found inside options array. Consider using rawValueMode");
            return e;
        }))), l !== this.disabled && (this.disabled = l, p(this), l && this.toggle(!1)), 
        this._endBatch();
    }
    selectOptions(t) {
        this.selectedOptions.differentByValue(t) && (g(this), this.selectedOptions.initialize(t), 
        p(this), this.opened || this._resetFilterValue(), this._endBatch());
    }
    toggle(t) {
        const e = t ?? !this.opened;
        e !== this.opened && (g(this), this.opened = e, p(this), e && this.inputElement?.focus(), 
        this._resetFilterValue(), this._endBatch());
    }
    getOptionId(t) {
        return this.id + "-option-" + t;
    }
    clearHighlight=() => {
        -1 !== this.highlightedOptionIndex && (g(this), this.highlightedOptionIndex = -1, 
        this.highlightedOption = t, p(this), this._endBatch());
    };
    _highlightRaw(t) {
        this.highlightedOptionIndex !== t && (g(this), this.highlightedOptionIndex = t, 
        this.highlightedOption = this.filteredOptions[t], p(this), this._endBatch());
    }
    highlight(t) {
        const e = Math.min(this.filteredOptions.length - 1, Math.max(t, 0));
        return !this.isOptionDisabled(this.filteredOptions[e], e) && (this._highlightRaw(e), 
        !0);
    }
    highlightRelative(t, e) {
        /*
                few iterations possible, so no sense to optimize
                by splitting loop and adding extra conditions
            */
        for (let i = t, s = this.filteredOptions.length; (i = (i + s + e) % s) !== t; ) if (!this.isOptionDisabled(this.filteredOptions[i], i)) {
            this._highlightRaw(i);
            break;
        }
    }
    scr() {
        const t = this.highlightedOptionIndex;
        -1 !== t && document.getElementById(this.getOptionId(t))?.scrollIntoView({
            block: "nearest"
        });
    }
    setInputElement=t => {
        this.inputElement = t;
    };
    setOuterElement=t => {
        this.outerElement = t;
    };
    _callChangeHandler() {
        this.onChange(this.selectedOptions.value), this.multiple && this.clearFilterValue();
    }
    toggleOption(t) {
        g(this), t === this.noneOption ? this.selectedOptions.clear() : (this.multiple || this.selectedOptions.clear(), 
        this.selectedOptions.toggle(t)), p(this), this._callChangeHandler(), this._endBatch();
    }
    selectWithPointer(t, e, i) {
        this.isOptionDisabled(t, e) ? i.preventDefault() : this.toggleOption(t);
    }
    updateFilteredOptions=() => {
        const e = this._transformedFilterValue ? this.options.filter(_, this) : this.options;
        if (/*@__NOINLINE__*/ r(e, this.filteredOptions) && (this.filteredOptions = e, p(this), 
        this.highlightedOption !== t && (this.highlightedOptionIndex >= e.length || this.highlightedOption !== e[this.highlightedOptionIndex]))) {
            const t = e.indexOf(this.highlightedOption);
            t > -1 ? this.highlight(t) : this.clearHighlight();
        }
    };
    clearFilterValue() {
        this.setFilterValue("");
    }
    setFilterValue(t) {
        g(this), t !== this.filterValue && (this.filterValue = t, this.onSearch(t), p(this));
        const e = l(t);
        e !== this._transformedFilterValue && (this._transformedFilterValue = e, this._queue(this.updateFilteredOptions)), 
        this._endBatch();
    }
    _resetFilterValue() {
        g(this);
        const t = this.multiple || !this.selectedOptions.length ? "" : this.getOptionLabel(this.selectedOptions.at(0));
        t !== this.filterValue && (this.filterValue = t, p(this)), "" !== this._transformedFilterValue && (this._transformedFilterValue = "", 
        this._queue(this.updateFilteredOptions)), this._endBatch();
    }
    clearAllOptions() {
        g(this), this.selectedOptions.clear(), p(this), this._resetFilterValue(), this._callChangeHandler(), 
        this._endBatch();
    }
    clearEvents={
        onPointerDown: t => {
            this.disabled || (this.clearable ? (t.stopPropagation(), t.preventDefault(), g(this), 
            this.clearAllOptions(), this.toggle(!1), this._endBatch()) : "production" !== process.env.NODE_ENV && console.warn("Trying to clear unclearable select"));
        }
    };
    arrowEvents={
        onPointerDown: t => {
            this.disabled || (t.stopPropagation(), t.preventDefault(), this.toggle());
        }
    };
    handlerEvents={
        onPointerDown: this.arrowEvents.onPointerDown,
        onBlur: () => {
            g(this), this.toggle(!1), 
            // clearing highlight here, because if otherwise highlightedOptionIndex remains not -1 and activedescendant attr is there, which is wrong
            this.clearHighlight(), this._endBatch();
        },
        onKeyDown: t => {
            if (!this.disabled) {
                this.lastKeyDownTimeStamp = t.timeStamp;
                const e = f[t.key];
                e ? e(this, t) : this.toggle(!0);
            }
        }
    };
    inputEvents={
        onChange: t => this.setFilterValue(t.target.value)
    };
    optionEvents(t, e) {
        return {
            onPointerEnter: t => {
                t.timeStamp - this.lastKeyDownTimeStamp > 256 && this.highlight(e);
            },
            onPointerDown: i => this.selectWithPointer(t, e, i)
        };
    }
    chipEvents={
        onKeyDown: t => {
            if (!this.disabled) {
                this.lastKeyDownTimeStamp = t.timeStamp;
                const e = O[t.key];
                e ? e(this, t) : d(this);
            }
        }
    };
    chipClearButtonEvents(t) {
        return {
            onPointerDown: e => {
                this.disabled || (e.stopPropagation(), e.preventDefault(), this.toggleOption(t));
            }
        };
    }
}

export { b as default, a as defaultNoneOption };
//# sourceMappingURL=index.js.map
